module.exports = __webpack_public_path__ + "media/images/yardstick-logo-black-spacing-9a7e0c0e877e5437aacfee01d730c81d.svg";